import swal from "sweetalert";
import { useState } from "react";
import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import { toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { sweetAl } from "../../../../core/helpers/message-helper";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import FormActividades from "../components/form-actividades";
import { activarActividad, inactivarActividad } from "../../services/actividades-service";

const Actividades = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState({});

    const modalActividad = useModal({
        title: "Crear actividad",
        data: { actividad: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSave = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("actividadesCrear")) {
        tableButtons.push({
            titleAttr: "Crear actividad",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalActividad.open({
                    title: "Crear actividad",
                    data: { actividad: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("actividadesEditar")) {
        tableButtons.push({
            titleAttr: "Editar actividad",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalActividad.open({
                    title: "Editar actividad",
                    data: { actividad: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("actividadesInactivar")) {
        tableButtons.push({
            titleAttr: "Inactivar actividad",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar esta actividad?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha inactivado la actividad");
                        break;
                    case "eliminar": {
                        const resp = await inactivarActividad(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar la actividad"
                            );
                        }

                        sweetAl.success(
                            "La actividad fue inactivada correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("actividadesActivar")) {
        tableButtons.push({
            titleAttr: "Activar actividad",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar esta area?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning("No se ha activado la actividad");
                        break;
                    case "activar": {
                        const resp = await activarActividad(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar la actividad"
                            );
                        }

                        sweetAl.success(
                            "la actividad fue activada correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "actividades",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaActividades",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/actividades`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de las actividades"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "icono" },
            { data: "color" },
            { data: "nombre_area" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: [2],
                createdCell: (td, cellData, rowData) => {
                    td.innerHTML = `
                    <i style="font-size: 30px; color: ${rowData.color}" class="${cellData}"></i>
                    `;
                },
            },
            {
                targets: [3],
                createdCell: (td, cellData) => {
                    td.innerHTML = `
                        <div style="width: 30px; height: 30px; background-color: ${cellData}"></div>
                    `;
                },
            },
            {
                targets: 5,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    NÓMINA / Actvidades
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tablaActividades"
                >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Icono</th>
                            <th>Color</th>
                            <th>Area</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormActividades modalState={modalActividad} onSave={onSave} />
        </ContentWrapper>
    );
};

export default Actividades;
